export default __webpack_public_path__ + "static/media/17225993.f7b07340.jpg";